import * as types from '@/store/mutation-types'

export default {
  [types.SET_SELECTED_LOCATION_GROUP](state, locationGroup) {
    state.selectedLocationGroup = locationGroup
    console.log(locationGroup)
  },
  [types.SET_CREATE_LOCATION_GROUP_DIALOG](state, payload) {
    state.createLocationGroupDialog = payload
  },
  [types.SET_LOCATION_GROUP_EDIT_DIALOG](state, payload) {
    state.locationGroupEditDialog = payload
  }
}
